import { render, staticRenderFns } from "./DSArrowLeftIcon.vue?vue&type=template&id=399cd6cc&"
import script from "./DSArrowLeftIcon.vue?vue&type=script&lang=js&"
export * from "./DSArrowLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports